import { request } from "../../apis";

export const apiGetCartItems = (): any =>
  request("get", `/api/user/order/cart`, null, true);

export const apiAddToCart = (params: any) =>
  request("put", `/api/user/order/cart`, params, true, true);

export const apiDeleteFromCart = (params: any) =>
  request(
    "delete",
    `/api/user/order/cart/${params.cart_number}`,
    null,
    true,
    true
  );

export const apiGetCartStatus = (): any =>
  request("get", `/api/user/order/cart/status`, null, true);
